import { useState, useContext } from 'react';
import _noop from 'lodash/noop';

import { AppContext, ModalContext } from 'commons-ui';
import useService from '../../useService';
import { RefundTournamentT } from '../types';
import { ADMIN_ACTION_TYPES } from './constants';

const useContent = (props: RefundTournamentT) => {
	const { handleForceUpdate = _noop, adminActionType = ADMIN_ACTION_TYPES.REFUND_TOURNAMENT, ltid, mttid, cgrid } = props;
	const { refundTournament } = useService({ ltid, mttid, cgrid });

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const { setModalConfig } = useContext(ModalContext);

	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			let data: any = { adminActionType };
			if (adminActionType === ADMIN_ACTION_TYPES.REFUND_TOURNAMENT) {
				const { reason, attachments, freshdeskTicketId } = submittedData;
				data = { ...data, reason, attachments, freshdeskTicketId };
			}
			await refundTournament(data);
			handleForceUpdate();
			showAlert('Tournament refunded successfully', { type: 'success' });
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while refunding tournament', { type: 'error' });
		} finally {
			setModalConfig({ isOpen: false });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		showLoader,
		setShowLoader,
		handleFormCancel,
		handleFormSubmit
	};
};

export default useContent;
